class ValidationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.fields = this.querySelectorAll('input.required, input.required-same, select.required');

    this.initialize();
  }

  initialize() {
    this.validateOnEntry()
    this.validateOnSubmit()
  }

  validateOnSubmit() {
    let self = this
    this.form.addEventListener('submit', e => {
      let validFields = []
      e
        .preventDefault()
        e
        .stopImmediatePropagation()

        self
        .fields
        .forEach(field => {
          const validValue = self.validateFields(field)
          validFields.push(validValue)
        })

      const validation = validFields.filter(value => value === false)

      if (validation.length == 0) {

        if (self.form.dataset.isAjax) {
          //e.target.querySelector("button[submit]").disabled = true;
          e.target.querySelector(".button").disabled = true;
          const submitEvent = new Event('validation-submit');
          this.form.dispatchEvent(submitEvent);
        } else {
          self.form.submit()
        }
        return true;
      }
    })
  }

  validateOnEntry() {
    let self = this
    this.fields.forEach(field => {

      field.addEventListener('input', event => {
        self.validateFields(field)
      })
    })
  }

  validateFields(field) {
    let isValid = true;

    // Check presence of values
    if (field.classList.contains('required')) {
      if (field.type === "checkbox") {

        if (field.checked) {
          this.setStatus(field, null, "success")
        } else {

          this.setStatus(field, "Pleace accept our terms and conditions", "error")
          isValid = false
        }
      } else {
        if (field.value.trim() === "") {
          this.setStatus(field, field.nextElementSibling.innerText + "                                          cannot be blank", "error")
          isValid = false
        } else {
          this.setStatus(field, null, "success")
        }
      }
    }

    // check for a valid email address
    if (field.type === "email") {
      const re = /\S+@\S+\.\S+/
      if (re.test(field.value)) {
        this.setStatus(field, null, "success")
      } else {
        this.setStatus(field, "Please enter valid email address", "error")
        isValid = false
      }
    }

    // check for a valid phone number
    if (field.type === "tel" && field.value !== "") {
      const re = /^\+[1-9]\d{10,14}$/
      if (re.test(field.value)) {
        this.setStatus(field, null, "success")
      } else {
        this.setStatus(field, "Format not allowed", "error")
        isValid = false
      }
    }

    // Password confirmation edge case
    if (field.id === "RegisterForm-email_confirm") {
      const passwordField = this.form.querySelector('#RegisterForm-email')

      if (field.value.trim() == "") {
        this.setStatus(field, "Email confirmation required", "error")
        isValid = false
      } else if (field.value != passwordField.value) {
        this.setStatus(field, "Email does not match", "error")
        isValid = false
      } else {
        this.setStatus(field, null, "success")
      }
    }

    // Password confirmation edge case
    if (field.id === "password_confirm") {
      const passwordField = this.form.querySelector('#password')

      if (field.classList.contains('required') && field.value.trim() == "") {
        this.setStatus(field, "Password confirmation required", "error")
        isValid = false
      } else if (field.value != passwordField.value) {
        this.setStatus(field, "Password does not match", "error")
        isValid = false
      } else {
        this.setStatus(field, null, "success")
      }
    }

    return isValid
  }

  setStatus(field, message, status) {

    if (field.tagName.toLowerCase() !== 'select') {
      let parentElement = field.parentElement
      let errorMessage = parentElement.querySelector('.error-message')

      if (status === "success") {
        if (errorMessage) {
          errorMessage.innerText = ""
        }
        parentElement.classList.replace('input-field-err', 'input-field');
        parentElement.querySelector('.error-message').classList.add('hidden')
      }

      if (status === "error") {
        parentElement.classList.replace('input-field', 'input-field-err');
        parentElement.querySelector('.error-message').innerText = message
        parentElement.querySelector('.error-message').classList.remove('hidden')
      }
    } else {
      let parentElement = field.closest('.select-field')
      let customSelectWrapper = field.parentElement.shadowRoot.querySelector('.select-wrapper')
      let errorMessage = parentElement.querySelector('.error-message')

      if (status === "success") {
        if (errorMessage) {
          errorMessage.innerText = ""
        }
        customSelectWrapper.classList.remove('select-field-err');
        parentElement.querySelector('.error-message').classList.add('hidden')
      }

      if (status === "error") {
        customSelectWrapper.classList.add('select-field-err');
        parentElement.querySelector('.error-message').innerText = message
        parentElement.querySelector('.error-message').classList.remove('hidden')
      }
    }
  }

}

customElements.define('validation-form', ValidationForm);